/**
 * 图片URL处理工具
 * 支持多环境：数据库只存相对路径，前端根据环境拼接域名
 */

/**
 * 获取完整的图片URL
 * @param {string} url - 图片URL（可能是相对路径或完整URL）
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(url) {
  if (!url) return ''
  
  // 如果已经是完整URL，直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  
  const baseUrl = process.env.VUE_APP_API_URL || ''
  
  // 避免重复拼接 /api
  if (baseUrl.endsWith('/api') && url.startsWith('/api/')) {
    return baseUrl + url.substring(4) // 去掉 '/api'，保留 '/'
  }
  
  // 兜底：如果 url 以 /uploads/ 开头但 baseUrl 不包含 /api，手动加上 /api
  if (url.startsWith('/uploads/') && !baseUrl.includes('/api')) {
    return baseUrl + '/api' + url
  }
  
  // 如果 baseUrl 不以 / 结尾，且 url 不以 / 开头，则添加 /
  if (!baseUrl.endsWith('/') && !url.startsWith('/')) {
    return baseUrl + '/' + url
  }
  
  return baseUrl + url
}

/**
 * 批量处理图片URL
 * @param {Array<string>} urls - 图片URL数组
 * @returns {Array<string>} 完整的图片URL数组
 */
export function getImageUrls(urls) {
  if (!urls || !Array.isArray(urls)) return []
  return urls.map(url => getImageUrl(url))
}

/**
 * 从JSON字符串解析图片URL数组
 * @param {string} jsonStr - JSON字符串，如 '["/api/uploads/xxx.jpg"]'
 * @returns {Array<string>} 完整的图片URL数组
 */
export function parseImageUrls(jsonStr) {
  if (!jsonStr) return []
  try {
    const urls = JSON.parse(jsonStr)
    return getImageUrls(urls)
  } catch (e) {
    console.error('解析图片URL失败:', e)
    return []
  }
}
